export const stagingEmail = (email: string) =>
  `partner-db2dc4+${email.replace("@", ".at.")}@inbox.mailtrap.io`;
